import { inject, Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";

@Injectable({
  providedIn: "root",
})
export class DialogHelper {
  private dialog: MatDialog = inject(MatDialog);

  closeAll(): void {
    if (this.dialog) {
      this.dialog.closeAll();
    }
  }

  closeTopDialog(): void {
    const openDialogs = this.dialog?.openDialogs;
    if (openDialogs?.length) {
      openDialogs[openDialogs.length - 1].close();
    }
  }
}
